module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticStyle: {
      "margin-bottom": "-5px"
    }
  }, [_c('h3', [_vm._v("Genetic Testing Registry")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg12": "",
      "xl12": ""
    }
  }, [_c('ContentLoaderSearch')], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-card', [_c('ContentLoaderPlaceholder')], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('ContentLoaderSidebar')], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('ContentLoaderSidebar')], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('ContentLoaderSidebar')], 1)], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aa24886","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/pages/LoadingTemplate.vue
// module id = 501
// module chunks = 0